<div class="filters-container">
    <div class="filters-container__button-first">
        <app-buttons-filters
            [isActive]="true"
            [type]="0"
            (click)="applyFilter({begin: null, end: null, type: 0})">Hoje
        </app-buttons-filters>
    </div>
    <div class="filters-container__button">
        <app-buttons-filters
            [type]="1"
            (click)="applyFilter({begin: null, end: null, type: 1})">&Uacute;ltimos 15 dias
        </app-buttons-filters>
    </div>
    <div class="filters-container__button">
        <app-buttons-filters
            [type]="2"
            (click)="applyFilter({begin: null, end: null, type: 2})">&Uacute;ltimos 30 dias
        </app-buttons-filters>
    </div>
    <div class="filters-container__datepicker">
        <input matInput
            class="filters-container__datepicker__input"
            placeholder="Selecionar Per&iacute;odo"
            [satDatepicker]="picker"
            [value]="filtersControls"
            [min]="minRangeDate"
            [max]="today"
            (click)="picker.open()"
            (dateChange)="applyFilter({begin: $event.value.begin, end: $event.value.end, type: 3})">
        <sat-datepicker #picker [beginDate]="today" [endDate]="today" [rangeMode]="true"></sat-datepicker>
        <sat-datepicker-toggle matSuffix [for]="picker"></sat-datepicker-toggle>
    </div>
</div>
